// extracted by mini-css-extract-plugin
export default {"logo":"MenuBar_logo__BJykk"};